import React from 'react';
import reactDom from 'react-dom';

import AdAmountView from './components/adamount/AdAmountView';
import ApiTokenView from './components/apitoken/ApiTokenView';
import CalendarSwitcher from './components/calendar/CalendarSwitcher';
import CustomerRelatedRecordsView from './components/customer/CustomerRelatedRecordsView';
import DashboardView from './components/dashboard/DashboardView';
import LeadSourceSelector from './components/leadsource-selector/LeadSourceSelector';
import LeadSourceView from './components/leadsource/LeadSourceView';
import LookupView from './components/lookup/LookupView';
import ReportView from './components/report/ReportView';
import ChangeLogList from './components/changeLog/ChangeLogList';
import UserView from './components/user/UserView';
import FranchiseView from './components/franchise/FranchiseView';
import UserControl from './components/user/UserControl';
import CustomerDeleteButton from './components/customer/CustomerDeleteButton';

function renderLookupView(targetElementId, lookupType, title) {
    const element = document.getElementById(targetElementId);
    if (lookupType === 'LeadSource') {
        reactDom.render(<LeadSourceView />, element);
    } else if (lookupType === "AreaType") {
        reactDom.render(<LookupView lookupType={lookupType} title={title} showExternal={true} />, element);
    } else {
        reactDom.render(<LookupView lookupType={lookupType} title={title} />, element);
    }
}

function renderAdAmountView(targetElementId) {
    reactDom.render(<AdAmountView />, document.getElementById(targetElementId));
}

function renderApiTokenView(targetElementId) {
    reactDom.render(<ApiTokenView />, document.getElementById(targetElementId));
}

function renderCustomerRelatedRecordsView(customerId) {
    reactDom.render(<CustomerRelatedRecordsView customerId={customerId} />,
        document.getElementById('customer-related-records-div'));
}

function renderDashboardView(targetElementId) {
    const element = document.getElementById(targetElementId);
    reactDom.render(<DashboardView />, element);
}

function renderCalendarView(targetElementId, appointment, view, newAppointment) {
    reactDom.render(<CalendarSwitcher appointment={appointment} calendarView={view} newAppointment={newAppointment}/>, document.getElementById(targetElementId));
}

function renderLeadSourceSelector(leadSourceId, subLeadSourceId, disabled) {
    const leadSourceError = document.getElementById('leadsource-error').innerHTML;
    const subLeadSourceError = document.getElementById('subleadsource-error').innerHTML;

    reactDom.render(
        <LeadSourceSelector
            disabled={disabled}
            leadSourceId={leadSourceId}
            leadSourceError={leadSourceError}
            subLeadSourceId={subLeadSourceId}
            subLeadSourceError={subLeadSourceError}
        />,
        document.getElementById('leadsource-selector-div'));
}

function renderReportView(targetElementId) {
    const element = document.getElementById(targetElementId);
    reactDom.render(<ReportView />, element);
}

function renderChangeLogView(targetElementId, customerId) {
    const element = document.getElementById(targetElementId);
    reactDom.render(<ChangeLogList customerId={customerId} />, element);
}

function renderUserControl(targetElementId) {
    reactDom.render(<UserControl />, document.getElementById(targetElementId));
}

function renderUserView(targetElementId) {
    const element = document.getElementById(targetElementId);
    reactDom.render(<UserView />, element);
}

function renderFranchiseView(targetElementId) {
    const element = document.getElementById(targetElementId);
    reactDom.render(<FranchiseView />, element);
}

window.renderCustomerDeleteButton = (elementId, props) => {
    const element = document.getElementById(elementId);
    reactDom.render(
        <CustomerDeleteButton {...props} />,
        element
    );
};

window.renderAdAmountView = renderAdAmountView;
window.renderApiTokenView = renderApiTokenView;
window.renderCustomerRelatedRecordsView = renderCustomerRelatedRecordsView;
window.renderDashboardView = renderDashboardView;
window.renderLeadSourceSelector = renderLeadSourceSelector;
window.renderLookupView = renderLookupView;
window.renderReportView = renderReportView;
window.renderChangeLogView = renderChangeLogView;
window.renderCalendarView = renderCalendarView;
window.renderUserView = renderUserView;
window.renderFranchiseView = renderFranchiseView;

renderUserControl('user-control');

//fix for schedulerLicenseKey not an option bug in fullCalendar
import { BASE_OPTION_REFINERS } from '@fullcalendar/react';
BASE_OPTION_REFINERS.schedulerLicenseKey = String;